import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import Layout from 'components/Layout';
import LinkButton from 'components/LinkButton';
import {useFormContext} from 'react-hook-form';
import {t} from 'ttag';
import {setUrl} from 'utils/request';

const Filter = () => {
    const methods = useFormContext();
    const search = methods.watch('search');
    const hasSearchValue = !!search;

    const handleSubmit = () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set('search', search);
        setUrl(`${window.Urls.catalog_view()}?${urlSearchParams.toString()}`);
    };

    return (
        <div>
            <form onSubmit={methods.handleSubmit(handleSubmit)}>
                <Layout.Chain className="max-w-xl">
                    <InputText
                        className="flex-1"
                        classNameInput="w-full"
                        isCompact={true}
                        name="search"
                        placeholder={t`Search by Product Code or Description`}
                    />
                    <SubmitButton
                        className="min-w-10"
                        disabled={!hasSearchValue}
                        icon="search"
                        kind="secondary"
                        size="sm"
                        title={t`Filter`}
                    />
                    {hasSearchValue && (
                        <LinkButton
                            className="min-w-10"
                            href={window.Urls.catalog_view()}
                            icon="close"
                            kind="secondary"
                            size="sm"
                            title={t`Clear`}
                        />
                    )}
                </Layout.Chain>
            </form>
        </div>
    );
};

export default Filter;
